module.exports = __webpack_public_path__ + "img/cashback-money-refund-icon.646ce2b3.png";